// extracted by mini-css-extract-plugin
export default {"accordion":"faq-item_accordion__F+83r"};